<template>
  <div class="index-footer">
    <img class="sydw" src="../../../assets/custom/hlj/index/footer-icon.png" alt="">
    <span>黑龙江农业经济职业学院版权所有</span>
    <span>中国黑龙江省牡丹江市西安区</span>
    <span>邮编：157041</span>
    <span>电话：0453-6402306</span>
    <span>黑ICP备06005807号-1</span>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.index-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0.2rem 0;
  background: #bf2d26;
  .sydw {
    width: 0.48rem;
    margin-right: 0.2rem;
  }
  span {
    font-weight: bold;
    font-size: 0.16rem;
    color: #ffffff;
    margin: 0 0.05rem;
  }
}
</style>